import { call, debounce, put, takeLatest } from 'redux-saga/effects'

import { createVendor as createVendorApi, searchVendors } from 'Service/Api'

import * as SearchVendorTypes from 'Redux/Types/SearchVendorTypes'
import * as SearchVendorActions from 'Redux/Actions/SearchVendorActions'

function* searchVendorsWorker({ payload }) {
  try {
    const searchType = 'O'
    const { data } = yield call(searchVendors, payload.searchTerm ?? '', searchType)
    yield put(SearchVendorActions.searchVendorsSucceeded(data))
  } catch (error) {
    yield put(SearchVendorActions.searchVendorsFailed(error))
  }
}

function* createVendor({ payload }) {
  try {
    const searchType = 'O'
    const { data } = yield call(createVendorApi, payload.searchTerm, searchType)
    yield put(SearchVendorActions.createVendorSucceeded(data))
  } catch (errors) {
    yield put(SearchVendorActions.createVendorFailed(errors))
  }
}

export default function* SearchVendorSaga() {
  yield takeLatest(SearchVendorTypes.CREATE_VENDOR, createVendor)
  yield debounce(500, SearchVendorTypes.SEARCH_VENDORS, searchVendorsWorker)
}
